import { render, staticRenderFns } from "./SearchServerField.vue?vue&type=template&id=bf8fcfe2&scoped=true&"
import script from "./SearchServerField.vue?vue&type=script&lang=js&"
export * from "./SearchServerField.vue?vue&type=script&lang=js&"
import style0 from "./SearchServerField.vue?vue&type=style&index=0&id=bf8fcfe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8fcfe2",
  null
  
)

export default component.exports